import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AttributeRuleCombination, AttributeRules } from '../../../_lib/components/AttributeRules/AttributeRules';
import { AttributeRule } from '../../../types/api/AttributeGroups';
import { translatePageType } from '../../../_lib/components/PageType/PageTypeTitle';
import { PageType } from '../../../types/api/PageType';

type PageMembershipMatchingRuleSettingsDefaultViewProps = {
  rules: AttributeRule[];
  ruleCombination: AttributeRuleCombination;
  areaPageType?: PageType;
  roleName?: string;
};

export function PageMembershipMatchingRuleSettingsDefault(props: PageMembershipMatchingRuleSettingsDefaultViewProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  const transformRules = (rules: AttributeRule[]) =>
    rules.map(rule => ({
      ...rule,
      conditionValue: rule.conditionValue ? rule.conditionValue : t('areaMatchingRule'),
    }));

  const heading = () => {
    if (props.areaPageType) {
      return t('matchingRule', { areaPageType: translatePageType(props.areaPageType) });
    }
    if (props.roleName) {
      return t('matchingRole', { areaPageType: props.roleName });
    }
  };

  return (
    <div className="page-membership-matching-rule-settings">
      <AttributeRules rules={transformRules(props.rules)} ruleCombination={props.ruleCombination} heading={heading()} />
    </div>
  );
}
export const PageMembershipMatchingRuleSettingsDefaultView = asView(PageMembershipMatchingRuleSettingsDefault);
export type PageMembershipMatchingRuleSettingsDefaultView = ComponentProps<
  typeof PageMembershipMatchingRuleSettingsDefault
>;
